import { identity } from 'lodash';

function getUrlParts(url) {
  const urlParts = url.split('/').filter(identity);
  return urlParts;
}

export function hasSubmenu(url) {
  const firstUrlPart = getUrlParts(url)[0];

  return ['survey', 'surveys', 'account'].includes(firstUrlPart);
}
export function isInSurveys(url) {
  const firstUrlPart = getUrlParts(url)[0];
  return ['survey', 'surveys', 'services'].includes(firstUrlPart);
}
export function isInSurveyListPage(url) {
  const firstUrlPart = getUrlParts(url)[0];
  return ['surveys'].includes(firstUrlPart);
}

export function isInAccount(url) {
  const firstUrlPart = getUrlParts(url)[0];
  return ['account'].includes(firstUrlPart);
}

export function isInSummary(url) {
  return url.includes('survey/summary');
}

export function isInQuestionnaire(url) {
  return url.includes('survey/questionnaire');
}

export function isInAdvancedLogic(url) {
  return url.includes('/advanced-logic');
}
